// extracted by mini-css-extract-plugin
export default {"list":"CardsContainer_list__XOXfC"};